import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import appReducer from '../appSlice';
import loginReducer from '../pages/login/loginSlice';
import emailReducer from '../pages/inbox/emailSlice';
import accountReducer from '../pages/account/accountSlice';
import sendAsReducer from '../pages/inbox/sendAsSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

const persistConfig = {
  key: 'root',
  storage,
  // sendAs is re-fetched on every Inbox mount so it never goes stale across reloads
  blacklist: ['app', 'sendAs']
}

const persistedReducer = persistReducer(persistConfig, combineReducers({
  app: appReducer,
  login: loginReducer,
  emails: emailReducer,
  account: accountReducer,
  sendAs: sendAsReducer
}));

const rootReducer = (state: any, action: any) => {
  const newState = persistedReducer(state, action);
  // logout only drops the active session (loginSlice.ts keeps any other logged-in accounts
  // around). Only nuke everything - including the unrelated app/emails slices - once that was
  // the last session, matching the original single-session "logout clears all stored data"
  // behavior instead of wiping other still-logged-in accounts off a partial logout.
  if (action.type === "login/logout" && newState.login.sessions.length === 0) {
    storage.removeItem("persist:root");
    return persistedReducer(undefined, action);
  }
  return newState;
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
